module.exports = __webpack_public_path__ + "img/ico_weather_info.3bb0d74d.svg";